import React from 'react';
import dateFormat from 'dateformat';
import { Link } from 'react-router-dom';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { useTranslation } from 'react-i18next';
import classes from './appliedJobCard.module.scss';
import { useQuery } from '../../../../utils/hooks';
import { setClassForStatusBubble } from '../../../../utils/helpers';

function AppliedJobCard(props) {
  const { job, jobId, cretedDate, status, menuHandler, dots } = props;
  const { t } = useTranslation();
  const query = useQuery();
  const isSavedTab = query.get('tab') === 'saved';

  return (
    <section className={classes.jobCard}>
      <div className={`${classes.titleContainer} d-flex gap-2 mb-1 flex-wrap`}>
        <span>{job?.JobTitle}</span>
        <Link to={`/dashboard/jobs/${jobId}`}>
          <span className={`${classes.textId} ${classes.secondaryText}`}>{jobId}</span>
        </Link>
      </div>
      <span className={`${classes.secondaryText} mb-3`}>{job?.Industry}</span>
      <div className="d-flex gap-2 mb-2 flex-wrap">
        <span className={`${classes.iconWithText} ${classes.secondaryText}`}>
          <LocationOnOutlinedIcon className={classes.iconWithTextIcon} />
          {job?.Location}
        </span>
        <span className={`${classes.iconWithText} ${classes.secondaryText}`}>
          <ArticleOutlinedIcon className={classes.iconWithTextIcon} />
          {job?.JobType}
        </span>
        {isSavedTab ? (
          <div>{!job?.IsActive ? <span className={classes.jobStatus}>{t('jobs.status.closed')}</span> : null}</div>
        ) : (
          <div className={`${classes.tags} ${setClassForStatusBubble(status, classes)}`}>{status}</div>
        )}
      </div>
      {!isSavedTab ? (
        <span className={classes.secondaryText}>{`${t('dashboard.jobs.appliedlist.dateapplied')} ${dateFormat(
          cretedDate,
          'dd mmm yyyy'
        )}`}</span>
      ) : null}
      {dots && (
        <div role="presentation" data-testid="menu" className={classes.threeDotMenu} onClick={menuHandler}>
          <MoreVertIcon />
        </div>
      )}
    </section>
  );
}

export default AppliedJobCard;
